/* eslint-disable react/no-children-prop */
import useExpandable from 'Hooks/useExpandable';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import AddTagButton from './components/AddTagButton';
import TagItems from './components/TagItems';
import {
  Wrapper
} from './styled';

const ID = 'tags';

const Tags = ({ serviceTags, entity }) => {
  const intl = useIntl();
  const isExpanded = useExpandable('general', ID, serviceTags);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  if (!hasTagsFeature) return null;

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="tags" title={ intl.formatMessage({ id: 'manage.detail.tab.general.tags' }) } tab="general">
      <Wrapper>
        <TagItems serviceTags={ serviceTags } />
        <AddTagButton entity={ entity } />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Tags;
